export interface Playlist {
  id: string
  name: string
  code: string
  total_lectures: number
  playlist_url: string | null
  playlist_id: string | null
  thumbnail_url: string | null
  video_count: number
  created_at: string
  // Joined
  lecture_count?: number
  completed_count?: number
  lectures?: Lecture[]
}

export interface Lecture {
  id: string
  course_id: string | null
  lecture_number: number
  title_ar: string | null
  title_en: string | null
  duration_minutes: number | null
  youtube_url: string | null
  youtube_id: string | null
  status: 'raw' | 'transcribed' | 'manufactured' | 'complete'
  created_at: string
  // Joined fields
  course_name?: string
}

export interface ManufacturingOutput {
  id: string
  lecture_id: string
  type: 'M1' | 'M2' | 'M3' | 'M4' | 'M5' | 'M6'
  data: any
  model_used: string | null
  cost_usd: number | null
  status: string
  created_at: string
}

export interface Product {
  id: string
  lecture_id: string | null
  domain_code: string | null
  type: string
  level: 'lecture' | 'domain'
  data: any
  r2_key: string | null
  model_used: string | null
  cost_usd: number | null
  status: string
  created_at: string
}

export interface Stats {
  total_lectures: number
  manufactured: number
  completed: number
  pending: number
  total_cost: number
  progress_percent: number
}

export type MType = 'M1' | 'M2' | 'M3' | 'M4' | 'M5' | 'M6'
export type PType = 'P1' | 'P3' | 'P4' | 'P5' | 'P6a' | 'P6b' | 'P6c' | 'P7' | 'P8' | 'P9'

export const M_LABELS: Record<MType, { ar: string; en: string }> = {
  M1: { ar: 'تقسيم بالتوقيت', en: 'Segmentation' },
  M2: { ar: 'ملخصات', en: 'Summaries' },
  M3: { ar: 'أسئلة المحاضر', en: 'Q&A' },
  M4: { ar: 'مصطلحات', en: 'Terms' },
  M5: { ar: 'أمثلة', en: 'Examples' },
  M6: { ar: 'خريطة المحتوى', en: 'Content Map' },
}

export const P_LABELS: Record<PType, { ar: string; en: string }> = {
  P1: { ar: 'أسئلة MCQ', en: 'MCQ Questions' },
  P3: { ar: 'مصطلحات', en: 'Glossary' },
  P4: { ar: 'ملخص مراجعة', en: 'Review Summary' },
  P5: { ar: 'بطاقات + Cheat', en: 'Flashcards' },
  P6a: { ar: 'اقتباسات', en: 'Hooks/Quotes' },
  P6b: { ar: 'بوستات', en: 'Social Posts' },
  P6c: { ar: 'سكريبتات فيديو', en: 'Video Scripts' },
  P7: { ar: 'بودكاست', en: 'Podcast' },
  P8: { ar: 'خريطة ذهنية', en: 'Mind Map' },
  P9: { ar: 'ESP محتوى', en: 'ESP Content' },
}
